<template>
    <div class="editer-right-component">
        <div class="search-memery-btn">
            <div class="btn-main" @click="$emit('action', 'searchTMDb')">
                <span>{{ $t("workbench.component_EditerRight_tips_1") }}</span>
                <svg-icon name="ib-search"></svg-icon>
            </div>
        </div>
        <!-- 标签信息块 -->
        <div class="tag-info-content" v-if="hasTagInfo">
            <div class="block-title margin-y-10">
                {{ $t("workbench.component_EditerRight_chunk_title_8") }}
            </div>
            <div class="tag-info-block">
                <div
                    class="tag-item"
                    v-for="(tag, index) in displayTagList"
                    :key="index"
                >
                    <span class="tag-id">{{ tag.id }}</span>
                    <span class="tag-original-data">{{
                        tag.originalData
                    }}</span>
                </div>
                <div
                    class="tag-expand-btn"
                    v-if="showExpandBtn"
                    @click="tagInfoExpanded = !tagInfoExpanded"
                >
                    <span v-if="tagInfoExpanded"
                        >{{
                            $t("workbench.component_EditerRight_tag_collapse")
                        }}
                        <i class="el-icon-arrow-up"></i
                    ></span>
                    <span v-else
                        >{{
                            $t("workbench.component_EditerRight_tag_expand")
                        }}
                        ({{ tagInfoList.length - 3 }})
                        <i class="el-icon-arrow-down"></i
                    ></span>
                </div>
                <!-- 原tag内容展示（已注释） -->
                <!-- <div
                    class="tag-text"
                    :lang="doc.sourceLang"
                    v-html="sourceTaggedTextHtml"
                ></div> -->
            </div>
        </div>
        <div class="jargon-content">
            <div class="block-title margin-y-10">
                {{ $t("workbench.component_EditerRight_chunk_title_1") }}
            </div>
            <div class="jargon-list">
                <template v-if="jargonsLoading">
                    <div class="loading-block">
                        <i class="el-icon-loading"></i>
                        {{ $t("workbench.component_EditerRight_tips_2") }}
                    </div>
                </template>
                <template v-else>
                    <template v-if="jargons.length > 0">
                        <div
                            class="item"
                            v-for="(item, index) in jargons"
                            :key="index"
                            @mousedown.prevent
                            @click="applyJargonBtnEvent(item)"
                        >
                            <div :lang="doc.sourceLang">{{ item.source }}</div>
                            <div :lang="doc.targetLang">
                                <el-tooltip
                                    :content="
                                        $t(
                                            'workbench.component_EditerRight_tips_3'
                                        )
                                    "
                                    placement="top"
                                >
                                    <span>{{ item.target }}</span>
                                </el-tooltip>
                            </div>
                            <div
                                class="fonts-12 color-666666"
                                v-if="item.description"
                            >
                                {{ $t("workbench.component_EditerRight_tips_4")
                                }}{{ item.description }}
                            </div>
                            <div class="fonts-16 color-666666">
                                <el-tooltip placement="top">
                                    <div class="line-height-1.5" slot="content">
                                        <div>
                                            {{
                                                $t(
                                                    "workbench.component_EditerRight_tips_12"
                                                )
                                            }}{{ item.asset?.name }}
                                        </div>
                                        <div>
                                            {{
                                                $t(
                                                    "workbench.component_EditerRight_tips_14"
                                                )
                                            }}{{
                                                item.asset?.createTime || "-"
                                            }}
                                        </div>
                                        <div>
                                            {{
                                                $t(
                                                    "workbench.component_EditerRight_tips_13"
                                                )
                                            }}{{ item.asset?.createBy || "-" }}
                                        </div>
                                        <div>
                                            {{
                                                $t(
                                                    "workbench.component_EditerRight_tips_15"
                                                )
                                            }}{{
                                                item.asset?.updateTime || "-"
                                            }}
                                        </div>
                                        <div>
                                            {{
                                                $t(
                                                    "workbench.component_EditerRight_tips_16"
                                                )
                                            }}{{ item.asset?.updateBy || "-" }}
                                        </div>
                                    </div>
                                    <svg-icon name="ib-info"></svg-icon>
                                </el-tooltip>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <!-- <div class="none-block" v-if="doc.splitMode === 'PARAGRAPH'">段落拆分模式不支持查询术语</div> -->
                        <div class="none-block">
                            {{
                                $t(
                                    "workbench.component_EditerRight_chunk_empty_message_1"
                                )
                            }}
                        </div>
                    </template>
                </template>
            </div>
        </div>
        <div class="memory-content">
            <div class="block-title margin-y-10">
                {{ $t("workbench.component_EditerRight_chunk_title_2") }}
            </div>
            <div class="memory-list">
                <template v-if="memoriesLoading">
                    <div class="loading-block">
                        <i class="el-icon-loading"></i>
                        {{ $t("workbench.component_EditerRight_tips_2") }}
                    </div>
                </template>
                <template v-else>
                    <template v-if="memories.length > 0">
                        <div
                            class="item"
                            v-for="(item, index) in memories"
                            :key="index"
                        >
                            <div class="line">
                                <div class="left">
                                    <el-tooltip
                                        placement="top"
                                        v-if="item.setting.length"
                                    >
                                        <div
                                            class="line-height-1.5"
                                            slot="content"
                                        >
                                            <template
                                                v-for="(
                                                    se, index
                                                ) in item.setting"
                                            >
                                                <div :key="index">
                                                    {{
                                                        se.penaltyType ===
                                                        "MEM_OT"
                                                            ? "翻译记忆库罚分"
                                                            : ""
                                                    }}
                                                    {{ se.penaltyPoints }}
                                                </div>
                                            </template>
                                        </div>
                                        <div
                                            :class="[
                                                'rate',
                                                item.rate === 100 ? '' : 'not',
                                            ]"
                                        >
                                            {{ item.rate }}%
                                        </div>
                                    </el-tooltip>
                                    <div
                                        :class="[
                                            'rate',
                                            item.rate === 100 ? '' : 'not',
                                        ]"
                                        v-else
                                    >
                                        {{ item.rate }}%
                                    </div>
                                </div>
                                <div class="right">
                                    <div
                                        class="source"
                                        :lang="doc.sourceLang"
                                        v-html="item.taggedSourceText"
                                    ></div>
                                </div>
                            </div>
                            <div class="line">
                                <div class="left">
                                    <div
                                        class="apply-btn"
                                        @click="applyMemoryBtnEvent(item)"
                                        v-if="sentPermission"
                                    >
                                        {{
                                            $t(
                                                "workbench.component_EditerRight_btn_1"
                                            )
                                        }}
                                    </div>
                                </div>
                                <div class="right">
                                    <div class="target" :lang="doc.targetLang">
                                        {{ item.target }}
                                    </div>
                                </div>
                            </div>
                            <div class="line margin-x-15">
                                <el-tooltip placement="top">
                                    <div class="line-height-1.5" slot="content">
                                        <div>
                                            {{
                                                $t(
                                                    "workbench.component_EditerRight_tips_5"
                                                )
                                            }}{{ item.asset.name }}
                                        </div>
                                        <div>
                                            {{
                                                $t(
                                                    "workbench.component_EditerRight_tips_11"
                                                )
                                            }}{{ item.asset.updateBy || "-" }}
                                        </div>
                                        <div>
                                            {{
                                                $t(
                                                    "workbench.component_EditerRight_tips_10"
                                                )
                                            }}{{ item.asset.updateTime || "-" }}
                                        </div>
                                        <div>
                                            {{
                                                $t(
                                                    "workbench.component_EditerRight_tips_17"
                                                )
                                            }}{{ item.asset.fileName || "-" }}
                                        </div>
                                        <div>
                                            {{
                                                $t(
                                                    "workbench.component_EditerRight_tips_18"
                                                )
                                            }}{{
                                                item.asset.projectName || "-"
                                            }}
                                        </div>
                                        <div>
                                            {{
                                                $t(
                                                    "workbench.component_EditerRight_tips_7"
                                                )
                                            }}{{ item.asset.createTime }}
                                        </div>
                                        <div>
                                            {{
                                                $t(
                                                    "workbench.component_EditerRight_tips_6"
                                                )
                                            }}{{ item.asset.createBy || "-" }}
                                        </div>
                                    </div>
                                    <div
                                        class="color-666666 fonts-12"
                                        style="max-width: 100%"
                                    >
                                        <div class="flex">
                                            <div class="flex-1 text-omission">
                                                <svg-icon
                                                    name="ib-info"
                                                ></svg-icon>
                                                {{ item.asset.name }}
                                            </div>
                                            <div
                                                class="flex-1 text-omission margin-l-5"
                                            >
                                                {{
                                                    item.asset.updateTime || "-"
                                                }}
                                            </div>
                                        </div>
                                        <div class="flex margin-t-5">
                                            <div class="flex-1 text-omission">
                                                {{
                                                    $t(
                                                        "workbench.component_EditerRight_tips_19"
                                                    )
                                                }}{{
                                                    item.asset.fileName || "-"
                                                }}
                                            </div>
                                            <div
                                                class="flex-1 text-omission margin-l-5"
                                            >
                                                {{
                                                    $t(
                                                        "workbench.component_EditerRight_tips_20"
                                                    )
                                                }}{{
                                                    item.asset.updateBy || "-"
                                                }}
                                            </div>
                                        </div>
                                    </div>
                                </el-tooltip>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div
                            class="none-block"
                            v-if="doc.splitMode === 'PARAGRAPH'"
                        >
                            {{
                                $t(
                                    "workbench.component_EditerRight_chunk_empty_message_2"
                                )
                            }}
                        </div>
                        <div class="none-block" v-else>
                            {{
                                $t(
                                    "workbench.component_EditerRight_chunk_empty_message_3"
                                )
                            }}
                        </div>
                    </template>
                </template>
            </div>
        </div>
        <div class="mt-content" v-if="isExcelFile">
            <div class="block-title margin-y-10">
                {{ $t("workbench.component_EditerRight_chunk_title_6") }}
            </div>
            <div class="mt-list">
                <template
                    v-if="currentSentence && currentSentence.translationNotes"
                >
                    <div class="item line-height-1.5">
                        <div class="padding-x-15 fonts-14">
                            {{ currentSentence.translationNotes }}
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="none-block">
                        {{
                            $t(
                                "workbench.component_EditerRight_chunk_empty_message_11"
                            )
                        }}
                    </div>
                </template>
            </div>
        </div>
        <div class="mt-content" v-if="isExcelFile">
            <div class="block-title margin-y-10">
                {{ $t("workbench.component_EditerRight_chunk_title_7") }}
            </div>
            <div class="mt-list">
                <template v-if="currentSentence && currentSentence.charLimit">
                    <div class="item line-height-1.5">
                        <div class="padding-x-15 fonts-14">
                            {{ currentSentence.charLimit }}
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="none-block">
                        {{
                            $t(
                                "workbench.component_EditerRight_chunk_empty_message_12"
                            )
                        }}
                    </div>
                </template>
            </div>
        </div>
        <div class="mt-content" v-if="doc.engineInfo">
            <div class="block-title margin-y-10">
                {{ $t("workbench.component_EditerRight_chunk_title_5") }}
                <el-tooltip
                    :content="
                        $t(
                            'workbench.component_EditerRight_chunk_empty_message_7'
                        )
                    "
                    placement="top"
                >
                    <svg-icon name="ib-question" class="margin-l-2"></svg-icon>
                </el-tooltip>
            </div>
            <div class="mt-list">
                <template v-if="translates?.engine?.ratingDetail">
                    <div class="item line-height-1.5">
                        <div class="padding-x-15 fonts-14">
                            <div class="">
                                {{
                                    $t(
                                        "workbench.component_EditerRight_chunk_empty_message_8",
                                        {
                                            score: translates.engine
                                                .ratingDetail.finalScore,
                                        }
                                    )
                                }}<span
                                    v-if="
                                        translates.engine?.ratingDetail
                                            ?.finalScore >= 100
                                    "
                                    >{{
                                        $t(
                                            "workbench.component_EditerRight_chunk_empty_message_9"
                                        )
                                    }}</span
                                >
                            </div>
                            <template
                                v-for="(se, seIndex) in translates.engine
                                    .ratingDetail.details"
                            >
                                <div
                                    :key="seIndex"
                                    v-if="se.deductionDetail.length"
                                >
                                    <div class="text-weight-500">
                                        {{ se.dimension }}
                                    </div>
                                    <template
                                        v-for="(
                                            de, deIndex
                                        ) in se.deductionDetail"
                                    >
                                        <div class="fonts-13" :key="deIndex">
                                            {{
                                                $t(
                                                    "workbench.component_EditerRight_chunk_empty_message_10",
                                                    {
                                                        type: de.deductibleItem,
                                                        reason: de.deductionReason,
                                                        score: de.totalDeducted,
                                                    }
                                                )
                                            }}
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="none-block">
                        {{
                            $t(
                                "workbench.component_EditerRight_chunk_empty_message_6"
                            )
                        }}
                    </div>
                </template>
            </div>
        </div>
        <!-- 编辑器译文右侧 - 机器翻译块(Machine Translation)，仅在引擎为 dji-common/dji-ui/dji-as 时展示 -->
        <div class="mt-content" v-if="isDjiEngine">
            <div class="block-title margin-y-10">
                {{ $t("workbench.component_EditerRight_chunk_title_3") }}
            </div>
            <div class="mt-list">
                <template>
                    <template v-if="translates.engine">
                        <div class="item">
                            <div class="translate-content">
                                <div class="icon-block">
                                    <el-tooltip
                                        placement="top"
                                        :content="
                                            $t(
                                                'workbench.component_EditerRight_tips_8',
                                                { name: translates.engine.name }
                                            )
                                        "
                                    >
                                        <svg-icon
                                            :name="
                                                'ie-' + translates.engine.engine
                                            "
                                        ></svg-icon>
                                    </el-tooltip>
                                </div>
                                <div
                                    class="translate-block"
                                    :lang="doc.targetLang"
                                    v-html="translates.engine.target"
                                ></div>
                            </div>
                            <div class="btn-content" v-if="sentPermission">
                                <div
                                    class="apply-btn"
                                    @click="applyBtnEvent(translates.engine)"
                                >
                                    {{
                                        $t(
                                            "workbench.component_EditerRight_btn_1"
                                        )
                                    }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div
                            class="none-block"
                            v-if="doc.splitMode === 'PARAGRAPH'"
                        >
                            {{
                                $t(
                                    "workbench.component_EditerRight_chunk_empty_message_4"
                                )
                            }}
                        </div>
                        <div class="none-block" v-else>
                            {{
                                $t(
                                    "workbench.component_EditerRight_chunk_empty_message_5"
                                )
                            }}
                        </div>
                    </template>
                </template>
            </div>
        </div>
        <div class="mt-content" v-if="doc.randomEngine">
            <div class="block-title margin-y-10">
                {{ $t("workbench.component_EditerRight_chunk_title_4") }}
                <!-- <span class="margin-l-5 cursor-pointer fonts-16" @click="showReferenceEngine"><svg-icon name="ib-edit"></svg-icon></span> -->
            </div>
            <div class="mt-list">
                <template v-if="translatesLoading">
                    <div class="loading-block">
                        <i class="el-icon-loading"></i>
                        {{ $t("workbench.component_EditerRight_tips_9") }}
                    </div>
                </template>
                <template v-else>
                    <template v-if="translates.reference">
                        <div class="item">
                            <div class="translate-content">
                                <div class="icon-block">
                                    <el-tooltip
                                        placement="top"
                                        :content="
                                            $t(
                                                'workbench.component_EditerRight_tips_8',
                                                {
                                                    name: translates.reference
                                                        .name,
                                                }
                                            )
                                        "
                                    >
                                        <svg-icon
                                            :name="
                                                'ie-' +
                                                translates.reference.engine
                                            "
                                        ></svg-icon>
                                    </el-tooltip>
                                </div>
                                <div
                                    class="translate-block"
                                    :lang="doc.targetLang"
                                    v-html="translates.reference.target"
                                ></div>
                            </div>
                            <div class="btn-content" v-if="sentPermission">
                                <div
                                    class="apply-btn"
                                    @click="applyBtnEvent(translates.reference)"
                                >
                                    {{
                                        $t(
                                            "workbench.component_EditerRight_btn_1"
                                        )
                                    }}
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div
                            class="none-block"
                            v-if="doc.splitMode === 'PARAGRAPH'"
                        >
                            {{
                                $t(
                                    "workbench.component_EditerRight_chunk_empty_message_4"
                                )
                            }}
                        </div>
                        <div class="none-block" v-else>
                            {{
                                $t(
                                    "workbench.component_EditerRight_chunk_empty_message_5"
                                )
                            }}
                        </div>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import config from "@/utils/config";
import tools from "@/utils/tools";
import Template from "../../project/Template.vue";
export default {
    components: { Template },
    name: "EditerRight",
    props: {
        jargonsLoading: false,
        translatesLoading: false,
        memoriesLoading: false,
        doc: {
            type: Object,
            default: {},
        },
        jargons: {
            type: Array,
            default: [],
        },
        memories: {
            type: Array,
            default: [],
        },
        translates: {
            type: Object,
            default: {},
        },
        sentPermission: {
            type: Boolean,
            default: false,
        },
        currentSentId: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            // engineDist:tools.getEngineDist(config.DOMAIN_AND_ENGINE_LIST),
            tagInfoExpanded: false, // 标签信息展开/收起状态
        };
    },
    computed: {
        ...mapState({
            engineDist: (state) => state.common.engineConfig,
        }),
        // 判断是否为Excel文件
        isExcelFile() {
            return (
                this.doc &&
                this.doc.fileType &&
                ["xlsx", "xls"].includes(this.doc.fileType)
            );
        },
        // 获取当前选中的句子
        currentSentence() {
            if (!this.currentSentId || !this.doc || !this.doc.sentences) {
                return null;
            }
            return (
                this.doc.sentences.find(
                    (sentence) => sentence.sentId === this.currentSentId
                ) || null
            );
        },
        // 获取带标签的原文HTML
        sourceTaggedTextHtml() {
            if (!this.currentSentence) {
                return "";
            }
            // 优先使用 sourceTaggedText，如果不存在则使用 sourceSegments 拼装
            if (this.currentSentence.sourceTaggedText) {
                return this.currentSentence.sourceTaggedText;
            }
            // 如果没有 sourceTaggedText，使用 sourceSegments 拼装
            return this.getSourceSegmentsHtml(
                this.currentSentence.sourceSegments
            );
        },
        // 获取标签信息列表（去重、排序）
        tagInfoList() {
            if (!this.currentSentence) {
                return [];
            }
            const segments = this.currentSentence.sourceSegments;
            if (!segments || segments.length === 0) {
                return [];
            }
            const tagMap = new Map();
            segments.forEach((item) => {
                if (item.tags && item.tags.length > 0) {
                    item.tags.forEach((tag) => {
                        if (tag.attrs && tag.attrs.id) {
                            if (!tagMap.has(tag.attrs.id)) {
                                tagMap.set(tag.attrs.id, {
                                    id: tag.attrs.id,
                                    originalData: tag.attrs.originalData || "",
                                });
                            }
                        }
                    });
                }
            });
            return Array.from(tagMap.values()).sort((a, b) => {
                const idA = parseInt(a.id, 10);
                const idB = parseInt(b.id, 10);
                return idA - idB;
            });
        },
        // 获取显示的标签列表（根据展开状态）
        displayTagList() {
            if (this.tagInfoExpanded) {
                return this.tagInfoList;
            }
            return this.tagInfoList.slice(0, 3);
        },
        // 判断是否需要显示展开/收起按钮
        showExpandBtn() {
            return this.tagInfoList.length > 3;
        },
        // 判断是否有 tag 信息
        hasTagInfo() {
            // 只对 dita 文件类型展示标签信息块
            if (!this.doc || this.doc.fileType !== "dita") {
                return false;
            }
            if (!this.currentSentence) {
                return false;
            }
            // 检查 sourceSegments 中的 tags 是否有内容
            const segments = this.currentSentence.sourceSegments;
            if (!segments || segments.length === 0) {
                return false;
            }
            return segments.some((item) => item.tags && item.tags.length > 0);
        },
        // 判断是否为 dji 引擎 (dji-common、dji-ui、dji-as)
        isDjiEngine() {
            if (!this.doc || !this.doc.engineInfo || !this.doc.engineInfo.key) {
                return false;
            }
            const engineKey = this.doc.engineInfo.key.split("@")[0];
            return ["dji-common", "dji-ui", "dji-as"].includes(engineKey);
        },
    },
    methods: {
        applyJargonBtnEvent(item) {
            if (this.sentPermission) {
                this.$emit("applyJargon", item);
            }
        },
        applyBtnEvent(item) {
            this.$emit("applyTranslate", item);
        },
        applyMemoryBtnEvent(item) {
            this.$emit("applyMemory", item);
        },
        showReferenceEngine() {
            this.$emit("action", "showReferenceEngine");
        },
        // 根据 sourceSegments 生成带标签的 HTML
        getSourceSegmentsHtml(segments) {
            if (!segments || segments.length === 0) {
                return "";
            }
            let html = [];
            segments.forEach((item) => {
                let styles = [];
                if (item.bold) {
                    styles.push("bold");
                }
                if (item.italic) {
                    styles.push("italic");
                }
                if (item.underline && item.underline !== "NONE") {
                    styles.push("underline");
                }
                if (item.strikeThrough) {
                    styles.push("strikethrough");
                }
                if (item.subscript) {
                    styles.push("subscript");
                }
                if (item.superscript) {
                    styles.push("superscript");
                }
                if (styles.length > 0) {
                    html.push(
                        `<span class="${styles.join(" ")}">${
                            item.text || ""
                        }</span>`
                    );
                } else {
                    html.push(item.text || "");
                }
            });
            return html.join("");
        },
    },
    mounted() {
        // console.log('xxx:::', this.doc)
    },
};
</script>
<style lang="scss" scoped>
.editer-right-component {
    height: 0;
    min-height: 100%;
    width: 340px;
    padding: 0 20px;
    overflow-y: auto;
    .block-title {
        font-weight: 500;
        font-size: 15px;
        line-height: 24px;
        color: #000000;
        display: flex;
        align-items: center;
        > i {
            font-size: 20px;
            font-weight: 500;
            margin-right: 5px;
        }
    }
    .search-memery-btn {
        padding: 15px 0px;
        border-bottom: 1px solid #f1f1f1;
        box-sizing: border-box;
        cursor: pointer;
        .btn-main {
            height: 40px;
            border: 1px solid #e5e5e5;
            box-sizing: border-box;
            border-radius: 6px;
            font-size: 14px;
            color: #808080;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 15px;
        }
    }
    .jargon-content {
        //margin-bottom: 30px;
        padding-bottom: 20px;
        border-bottom: 1px solid #f1f1f1;
        > .jargon-list {
            display: flex;
            flex-wrap: wrap;
            > .item {
                border-radius: 36px;
                margin-bottom: 10px;
                margin-right: 10px;
                padding: 8px 20px;
                font-size: 14px;
                line-height: 20px;
                // box-sizing: border-box;
                // border: 1px solid #00D959;
                background-color: #fafafa;
                > div {
                    float: left;
                    margin-right: 20px;
                    &:nth-child(2) {
                        color: #00b670;
                        cursor: pointer;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
        }
    }
    .memory-content {
        // margin-bottom: 30px;
        padding-bottom: 20px;
        border-bottom: 1px solid #f1f1f1;
        > .memory-list {
            > .item {
                background-color: #fafafa;
                border-radius: 8px;
                margin-bottom: 10px;
                display: flex;
                flex-direction: column;
                > .line {
                    display: flex;
                    margin-right: 10px;
                    margin-bottom: 10px;
                    &:first-child {
                        margin-top: 20px;
                    }
                    &:last-child {
                        margin-bottom: 20px;
                    }
                    > .left {
                        width: 44px;
                        > .rate {
                            // width:100%;
                            height: 24px;
                            color: #00b670;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-weight: 600;
                            font-size: 12px;
                            &.not {
                                color: #fe8e0b;
                            }
                        }
                    }
                    > .right {
                        flex: 1;
                        margin-left: 5px;
                        margin-right: 10px;
                        font-size: 14px;
                        line-height: 20px;
                        color: #000000;
                        font-size: 14px;
                        line-height: 20px;
                        > .source {
                            color: #00000080;
                            ::v-deep .diff-highlight {
                                color: #00b670;
                            }
                            .delete {
                                color: #fe8e0b;
                                text-decoration: line-through;
                            }
                            .insert {
                                color: #00b670;
                            }
                        }
                        word-wrap: break-word;
                    }
                    .apply-btn {
                        width: 40px;
                        height: 24px;
                        border-radius: 0 20px 20px 0;
                        background: #7dd6b3;
                        text-align: center;
                        line-height: 24px;
                        font-size: 12px;
                        color: #ffffff;
                        margin-bottom: 10px;
                        cursor: pointer;
                    }
                }
            }
        }
    }
    .mt-content {
        // margin-bottom: 30px;
        padding-bottom: 20px;
        border-bottom: 1px solid #f1f1f1;
        > .mt-list {
            > .item {
                background-color: #fafafa;
                border-radius: 8px;
                margin-bottom: 10px;
                padding: 20px 0px;
                > .translate-content {
                    padding: 0 10px;
                    display: flex;
                    > .icon-block {
                        > svg {
                            font-size: 20px;
                        }
                    }
                    > .translate-block {
                        flex: 1;
                        margin-left: 10px;
                        font-size: 14px;
                        line-height: 20px;
                        color: #000000;
                        word-wrap: break-word;
                        // word-break: break-all;
                    }
                }
                > .btn-content {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 10px;
                    > .apply-btn {
                        width: 44px;
                        height: 24px;
                        border-radius: 0 20px 20px 0;
                        background: #7dd6b3;
                        text-align: center;
                        line-height: 24px;
                        font-size: 12px;
                        color: #ffffff;
                        cursor: pointer;
                    }
                    > .score-text {
                        font-size: 12px;
                        margin-right: 10px;
                    }
                }
            }
        }
    }
    .bg-memory-name {
        background: #0000001a;
        padding: 2px 5px;
        border-radius: 6px;
    }
    .tag-info-content {
        padding-bottom: 20px;
        border-bottom: 1px solid #f1f1f1;
        .tag-info-block {
            background-color: #f8fcf9;
            border-radius: 8px;
            padding: 12px;
            border: 1px solid #e8f5ee;
            .tag-item {
                display: flex;
                align-items: flex-start;
                margin-bottom: 10px;
                padding: 8px 10px;
                background-color: #ffffff;
                border-radius: 6px;
                border: 1px solid #e8f5ee;
                &:last-child {
                    margin-bottom: 0;
                }
                .tag-id {
                    min-width: 24px;
                    height: 24px;
                    line-height: 24px;
                    text-align: center;
                    background-color: #7dd6b3;
                    border-radius: 12px;
                    font-size: 12px;
                    font-weight: 600;
                    color: #ffffff;
                    margin-right: 10px;
                    flex-shrink: 0;
                }
                .tag-original-data {
                    font-size: 13px;
                    line-height: 24px;
                    color: #333333;
                    word-break: break-all;
                    font-family: "Monaco", "Menlo", "Consolas", monospace;
                    background-color: #f5f5f5;
                    padding: 2px 8px;
                    border-radius: 4px;
                }
            }
            .tag-expand-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 8px;
                margin-top: 8px;
                background-color: #f0f0f0;
                border-radius: 4px;
                cursor: pointer;
                font-size: 13px;
                color: #666666;
                transition: background-color 0.2s;
                &:hover {
                    background-color: #e0e0e0;
                }
                i {
                    margin-left: 4px;
                    font-size: 12px;
                }
            }
            .tag-text {
                font-size: 14px;
                line-height: 20px;
                color: #000000;
                word-wrap: break-word;
                margin-top: 10px;
                .bold {
                    font-weight: bold;
                }
                .italic {
                    font-style: italic;
                }
                .underline {
                    text-decoration: underline;
                }
                .strikethrough {
                    text-decoration: line-through;
                }
                .subscript {
                    vertical-align: sub;
                    font-size: smaller;
                }
                .superscript {
                    vertical-align: super;
                    font-size: smaller;
                }
            }
        }
    }
}
/* @media  screen and(max-width:1600px){
    .editer-right-component{
        width:300px;
    }
} */
</style>
<style lang="scss"></style>
